"use strict";

exports.__esModule = true;
exports.isMediaObject = isMediaObject;
exports.getMediaObject = getMediaObject;
exports.getMediaButtons = getMediaButtons;
exports.getMediaObjectUi = getMediaObjectUi;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function isMediaObject(schema) {
  if (schema.type === "object" && schema.properties) {
    if (schema.properties.hasOwnProperty('mediaId')) {
      return true;
    }
  }

  return false;
}

function getMediaObject(props, mediaType) {
  if (!mediaType && props.mediaType) {
    mediaType = props.mediaType;
  }

  let content = props.content,
      hotspot = props.hotspot,
      focalpoint = props.focalpoint,
      cropdata = props.cropdata,
      properties = props.properties;
  let schema = {
    "type": "object",
    "properties": {
      "mediaId": {
        "type": "string",
        "readonly": true
      },
      "media": {
        "type": "object",
        "properties": {
          "mediaType": {
            "type": "string",
            "readonly": true
          }
        }
      }
    }
  };

  if (mediaType) {
    schema.properties.media.properties.mediaType = {
      "type": "string",
      "default": mediaType,
      "readonly": true
    };
  }

  if (mediaType === "image") {
    focalpoint = true;
    cropdata = true;

    if (focalpoint) {
      schema.properties.focalpoint = {
        "type": "object",
        "properties": {
          "x": {
            "type": "number",
            "readonly": true
          },
          "y": {
            "type": "number",
            "readonly": true
          }
        }
      };
    }

    if (cropdata) {
      schema.properties.cropdata = {
        "type": "object",
        "properties": {
          "x": {
            "type": "number",
            "readonly": true
          },
          "y": {
            "type": "number",
            "readonly": true
          }
        }
      };
    }
  }

  if (content) {
    schema.properties.content = content;
  }

  if (properties) {
    schema.properties = _extends({}, schema.properties, {}, properties);
  }

  return schema;
}

function getMediaButtons(props) {
  let uiOptions = props.uiOptions,
      schema = props.schema;
  let buttons = uiOptions.buttons; // buttons

  if (!buttons) {
    buttons = ["upload"];
  }

  return buttons;
}

function getMediaObjectUi(props) {
  let uiOptions = props.uiOptions,
      schema = props.schema,
      formData = props.formData,
      isArrayItem = props.isArrayItem;
  /*
  
  // collapsible
  
  let collapsible, editable
   collapsible = false;
  editable = true;
   // deletable, restorable
  
  let hideable, deletable, restorable;
  
  hideable = true;
  deletable = true;
   */

  let mediaId, media, uploadProgress;

  if (formData && formData.mediaId) {
    mediaId = formData.mediaId;
  }

  if (formData && formData.media) {
    media = formData.media;
  }

  if (formData && formData.uploadProgress) {
    uploadProgress = formData.uploadProgress;
  } // defaults


  let collapsible = uiOptions.collapsible,
      expanded = uiOptions.expanded,
      editable = uiOptions.editable,
      hideable = uiOptions.hideable,
      deletable = uiOptions.deletable,
      restorable = uiOptions.restorable,
      layout = uiOptions.layout,
      fieldset = uiOptions.fieldset,
      nav = uiOptions.nav,
      hotspot = uiOptions.hotspot,
      focalpoint = uiOptions.focalpoint,
      cropdata = uiOptions.cropdata;
  collapsible = Boolean(uiOptions.collapsible) || false;
  editable = Boolean(uiOptions.editable) || false;
  hideable = Boolean(uiOptions.hideable) || true;
  deletable = Boolean(uiOptions.deletable) || true;

  if (!layout && isArrayItem) {
    layout = "module";
  } else if (!layout) {
    layout = "media";
  } // buttons


  const buttons = getMediaButtons(props); // hotspot, focalpoint, cropdata

  if (!fieldset) {
    fieldset = [];

    if (schema.properties.content) {
      fieldset.push("content");
    }

    if (hotspot) {
      focalpoint = true;
      cropdata = true;
    }

    if (focalpoint) {
      fieldset.push("focalpoint");
    }

    if (cropdata) {
      fieldset.push("cropdata");
    }
  } // fieldset + nav


  if (fieldset && fieldset.length) {
    //        collapsible = true;
    editable = true;
    nav = true;
  }
  /*    
  if (layout === "module" && fieldset && fieldset.length) {
  }
   if (layout === "media") {
      
      if (fieldset && fieldset.length) {
          editable = true;
          collapsible = true;
          nav = true;
      }
      
  }
  */
  // title, label, imageUrl


  let title, label, imageUrl;

  if (media && media.title) {
    title = media.title;
  }

  if (media && media.mediaType) {
    label = media.mediaType;
  }

  if (media && media.imageUrl) {
    imageUrl = media.imageUrl;
  }

  return _extends({}, uiOptions, {
    mediaId: mediaId,
    media: media,
    uploadProgress: uploadProgress,
    title: title,
    label: label,
    imageUrl: imageUrl,
    collapsible: collapsible,
    expanded: expanded,
    editable: editable,
    hideable: hideable,
    deletable: deletable,
    restorable: restorable,
    layout: layout,
    fieldset: fieldset,
    nav: nav,
    buttons: buttons
  });
}